"use client";

import { Text } from "@zapier/design-system";
import { Template } from "src/types";
import styles from "./AppsSection.module.css";
import { useAppDetailsBySlugs } from "src/hooks";

type Props = {
  template: Template;
};

/**
 * AppsSection is a component that displays a list of apps that are used in a template.
 */
export const AppsSection = ({ template }: Props) => {
  const apps = template.apps;
  if (!apps?.length) {
    return null;
  }

  const { data: appDetails, isLoading: isLoadingAppDetails } =
    useAppDetailsBySlugs({ slugs: apps });

  const getAppName = (app: string) => {
    if (isLoadingAppDetails) {
      return "";
    }
    return appDetails?.get(app)?.name ?? app;
  };

  return (
    <section>
      <Text
        type="ParagraphHeader2"
        className={styles.sidebarSectionTitle}
        tag="h2"
      >
        Apps
      </Text>
      <ul className={styles.apps}>
        {apps.map((app) => (
          <li className={styles.app} key={app}>
            <div className={styles.appIconContainer}>
              <img
                className={styles.appIcon}
                src={`https://zapier.com/generated/${encodeURIComponent(app)}/64`}
                alt={`${app} icon`}
              />
            </div>
            <Text type="Body3">{getAppName(app)}</Text>
          </li>
        ))}
      </ul>
    </section>
  );
};
